import { LinkType, recognizeLinkTypeByUrl } from './recognizeLinkTypeByUrl';
import { parseUrl } from './parseUrl';

export function isSupportedUrlForPlayerWidget(url: string): boolean {
  try {
    const parsedURL = parseUrl(url);
    const recognizedService = recognizeLinkTypeByUrl(parsedURL);
    return SupportedServicesForPlayerWidget.includes(recognizedService);
  } catch {
    return false;
  }
}

export const SupportedServicesForPlayerWidget = [
  LinkType.spotify,
  LinkType.applemusic,
  LinkType.tidal,
  LinkType.youtube,
  LinkType.amazonmusic,
  LinkType.soundcloud,
  LinkType.deezer,
  LinkType.napster,
  LinkType.boomplay,
  LinkType.qobuz,
  LinkType.zvuk,
];
